export function TagPicker({ label, options, selected, onChange, testidPrefix }) {
  const toggle = (opt) => {
    if (selected.includes(opt)) onChange(selected.filter((s) => s !== opt));
    else onChange([...selected, opt]);
  };
  return (
    <div>
      <label className="font-mono text-xs uppercase tracking-[0.18em] text-ash mb-3 block">{label}</label>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = selected.includes(opt);
          return (
            <button
              key={opt}
              type="button"
              data-testid={`${testidPrefix}-${opt.replace(/[^a-zA-Z0-9]/g, "-")}`}
              onClick={() => toggle(opt)}
              className={`border px-3 py-1.5 font-mono text-[11px] uppercase tracking-wide transition-colors ${
                active
                  ? "border-gold bg-gold text-ink"
                  : "border-line text-ash hover:border-gold hover:text-gold"
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}
